export const FEATURE_NAME = "vehicle-tracker";

/** Forensic body codes emitted by the traffic-classification-core classify step. */
export enum VehicleType {
  unknown = "unknown",
  TIP = "TIP",
  SKP = "SKP",
  UTE = "UTE",
  VAN = "VAN",
  SUV = "SUV",
  HATCH = "HATCH",
  SED = "SED",
  REF = "REF",
  BUS = "BUS",
  MIX = "MIX",
  SEMI = "SEMI",
  TNK = "TNK",
  FLT = "FLT",
  CRN = "CRN",
  MOTO = "MOTO",
  TRK = "TRK",
}

export const VEHICLE_TYPE_LABELS: Record<VehicleType, string> = {
  [VehicleType.unknown]: "unknown",
  [VehicleType.TIP]: "tipper",
  [VehicleType.SKP]: "skip truck",
  [VehicleType.UTE]: "ute",
  [VehicleType.VAN]: "van",
  [VehicleType.SUV]: "SUV",
  [VehicleType.HATCH]: "hatchback",
  [VehicleType.SED]: "sedan",
  [VehicleType.REF]: "refuse truck",
  [VehicleType.BUS]: "bus",
  [VehicleType.MIX]: "cement mixer",
  [VehicleType.SEMI]: "semi-trailer",
  [VehicleType.TNK]: "tanker",
  [VehicleType.FLT]: "flatbed",
  [VehicleType.CRN]: "mobile crane",
  [VehicleType.MOTO]: "motorcycle",
  [VehicleType.TRK]: "truck",
};

export const VEHICLE_TYPE_VALUES: VehicleType[] = [
  VehicleType.UTE,
  VehicleType.TRK,
  VehicleType.FLT,
  VehicleType.TIP,
  VehicleType.SKP,
  VehicleType.REF,
  VehicleType.VAN,
  VehicleType.TNK,
  VehicleType.CRN,
  VehicleType.MIX,
  VehicleType.SEMI,
  VehicleType.BUS,
  VehicleType.SUV,
  VehicleType.HATCH,
  VehicleType.SED,
  VehicleType.MOTO,
  VehicleType.unknown,
];

export const VEHICLE_TYPE_GROUP: Record<VehicleType, string> = {
  [VehicleType.UTE]: "Commercial & heavy vehicles",
  [VehicleType.TRK]: "Commercial & heavy vehicles",
  [VehicleType.TIP]: "Commercial & heavy vehicles",
  [VehicleType.SKP]: "Commercial & heavy vehicles",
  [VehicleType.REF]: "Commercial & heavy vehicles",
  [VehicleType.VAN]: "Commercial & heavy vehicles",
  [VehicleType.SEMI]: "Commercial & heavy vehicles",
  [VehicleType.TNK]: "Commercial & heavy vehicles",
  [VehicleType.FLT]: "Commercial & heavy vehicles",
  [VehicleType.CRN]: "Commercial & heavy vehicles",
  [VehicleType.MIX]: "Commercial & heavy vehicles",
  [VehicleType.BUS]: "Commercial & heavy vehicles",
  [VehicleType.SUV]: "Passenger vehicles",
  [VehicleType.HATCH]: "Passenger vehicles",
  [VehicleType.SED]: "Passenger vehicles",
  [VehicleType.MOTO]: "Passenger vehicles",
  [VehicleType.unknown]: "Passenger vehicles",
};

export const LOAD_STATUSES = ["empty", "partial", "full", "overloaded", "covered", "unknown"] as const;

export type LoadStatus = (typeof LOAD_STATUSES)[number];

export const ATTRIBUTE_KEYS = [
  "bull_bar",
  "rack",
  "sign_text",
  "tray",
  "trailer",
  "doors_2",
  "doors_4",
  "dmg",
] as const;

export type AttributeKey = (typeof ATTRIBUTE_KEYS)[number];

export const ATTRIBUTE_LABELS: Partial<Record<AttributeKey, string>> = {
  dmg: "Visible damage",
  sign_text: "Has signage",
  tray: "Has tray",
  trailer: "Towing trailer",
  doors_2: "2 doors",
  doors_4: "4 doors",
};

export const ATTRIBUTE_FILTER_VALUES: Record<string, { key: string; value: unknown }> = {
  doors_2: { key: "doors", value: 2 },
  doors_4: { key: "doors", value: 4 },
};

export function getAttributeLabel(key: string): string {
  return (
    ATTRIBUTE_LABELS[key as AttributeKey] ?? key.charAt(0).toUpperCase() + key.slice(1).toLowerCase().replace(/_/g, " ")
  );
}
